import { useEffect } from "react";
import { animate, createScope, stagger } from "animejs";

/** Entrance motion only; never advances the login flow. */
export default function useLoginEntrance(root, selector, step = "login") {
  useEffect(() => {
    const preference = window.matchMedia("(prefers-reduced-motion: reduce)");
    let scope;
    const start = () => {
      scope?.revert();
      scope = undefined;
      if (preference.matches) return;
      scope = createScope({ root }).add(() => {
        animate(selector, {
          opacity: [0, 1], y: [18, 0],
          duration: 500, delay: stagger(45), ease: "out(3)",
        });
      });
    };
    start();
    preference.addEventListener("change", start);
    return () => { preference.removeEventListener("change", start); scope?.revert(); };
  }, [root, selector, step]);
}
